exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir=ltr] .btn-open-lang[data-v-b7e729c4]{margin-left:.93333rem}[dir=rtl] .btn-open-lang[data-v-b7e729c4]{margin-right:.93333rem}.autoHeight[data-v-b7e729c4]{margin-top:2.34667rem!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b7e729c4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/InCompleteSiteHead.vue
// module id = YG3C
// module chunks = 0